<template>
	<div>
		<div v-if="current.payment_id" class="row">
			<div class="col-xs-12 col-lg-12">
			</div>
		</div>
		<div class="row">
			<div class="col-xs-12 col-lg-12 container">
				<div class="col-xs-12 col-lg-12 container-collapse">
					<div class="row">
						<div class="col-xs-12 col-lg-12" @click="show_detail = !show_detail">
							<div class="container-collapse-header">
								<span><b>Detalhe</b></span>
								<span class="collapse-header-arrow" v-if="show_detail"><i class="fa fa-chevron-up"></i></span>
								<span class="collapse-header-arrow" v-else><i class="fa fa-chevron-down"></i></span>
							</div>
						</div>
						<div v-show="show_detail" class="col-xs-12 col-lg-12 container-collapse-body">
							<table class="table">
								<tbody>
									<tr>
										<td><b>Número da entrega</b></td>
										<td>{{ current.document_number }}</td>
									</tr>
									<tr v-if="!payment_status">
                                        <td><b>Pagamento</b></td>
                                        <td>
                                            <ul class="list-unstyled">
                                                <li v-for="(pag, idx) in current.payment" :key="idx"><b>{{ getPaymentMethod(pag.type) }}:</b> {{ getMoney(pag.value) }}</li>
                                            </ul>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><b>Valor total</b></td>
                                        <td>
                                            <span v-if="current.payment">
                                                R$ {{ current.payment.reduce((t, p) => t + parseFloat(p.value), 0).toFixed(2).replace(".", ",") }}
                                            </span>
                                            <span v-else>
                                                N/A
                                            </span>
                                        </td>
                                    </tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
				<div v-if="payment_status" class="col-xs-12 col-lg-12 container-collapse">
					<div class="row">
						<div class="col-xs-12 col-lg-12" @click="show_detail = !show_detail">
							<div class="container-collapse-header">
								<span><b>Pagamento</b></span>
								<span class="collapse-header-arrow" v-if="show_detail"><i class="fa fa-chevron-up"></i></span>
								<span class="collapse-header-arrow" v-else><i class="fa fa-chevron-down"></i></span>
							</div>
						</div>
						<div v-show="show_detail" class="col-xs-12 col-lg-12 container-collapse-body">
							<table class="table">
								<tbody>
									<tr>
										<td><b>Número da nota</b></td>
										<td>{{ current.document_number }}</td>
									</tr>
									<tr>
										<td><b>ID do link de pagamento</b></td>
										<td>{{ current.payment_id }}</td>
									</tr>
									<tr>
										<td><b>URL do link de pagamento</b></td>
										<td>
											<span style="position: relative; padding-left: 40px;">
                                                <a class="button-copy" href="#" @click.prevent.stop="copy(current.payment_url);" ><i class="fa fa-copy"></i></a> 
                                                {{ current.payment_url }}
                                            </span>
										</td>
									</tr>
									<tr>
										<td><b>Status do pagamento</b></td>
										<td>
											<span v-if="loading"><i class='fa fa-fw fa-circle-notch fa-spin'></i> CARREGANDO...</span>
											<span v-if="!loading && payment_status != null && payment_status" style="color: green;"><i class='fa fa-fw fa-check'></i> PAGO</span>
											<span v-if="!loading && payment_status != null && !payment_status" style="color: red;"><i class='fa fa-fw fa-ban'></i> PAGAMENTO NÃO ENCONTRADO</span>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Api from "@/lib/Api";

export default {
	name: "DeliveryPayment",

	props: {
		current: {
			type: Object,
			require: true,
		},
	},

	data: function() {
		return {
			loading: false,
			payment_status: null,
			show_detail: true,
		}
	},

	mounted: function() {
		if (this.current.payment_id) this.get_payment();
	},

	methods: {
		get_payment: async function() {
			this.loading = true;
			this.payment_status = "";

			let res = await Api.post("delivery/has-payment", { delivery_id: this.current.id });
			if (res.error) {
				this.$notification.error(res.data);
				this.close();
				this.loading = false;
				return;
			}

			if (res.data) {
				this.payment_status = true;
			} else {
				this.payment_status = false;
			}
			this.loading = false;
		},

		// Formata o valor em dinheiro
		getMoney: function(money) {
			let moneyAux = money.replace(",", ".").split(".");
			if(moneyAux.length > 1) {
				if (moneyAux[1].length > 1) {
					return "R$ " + moneyAux[0] + "," + moneyAux[1];
				} else {
					return "R$ " + moneyAux[0] + "," + moneyAux[1] + "0";
				}
			} else {
				return "R$ " + moneyAux[0] + ",00";
			}
		},

		getPaymentMethod: function(data) {
			if (data == '01')  return 'Dinheiro';
			if (data == '02')  return 'Cheque';
			if (data == '03')  return 'Cartão de Crédito';
			if (data == '04')  return 'Cartão de Débito';
			if (data == '05')  return 'Crédito Loja';
			if (data == '10')  return 'Vale Alimentação';
			if (data == '11')  return 'Vale Refeição';
			if (data == '12')  return 'Vale Presente';
			if (data == '13')  return 'Vale Combustível';

			return 'Outros';
		},

		copy: function(str) {
			let copyText = document.createElement("input"); //document.getElementById("myInput");
			copyText.type = "text";
			copyText.value = str;

			document.body.appendChild(copyText);
			copyText.select();
			copyText.setSelectionRange(0, 99999);
			document.execCommand("copy");

			copyText.remove();

			this.$notification.success("Copiado para área de transferência.");
		},
	}
}
</script>

<style scoped>
	.container {
        margin-top: 15px;
    }

    .container-collapse {
        margin-bottom: 15px;
        border: 1px solid #ddd;
        border-radius: 5px;
        padding: 15px;
    }

    .container-collapse-header {
        cursor: pointer;
    }

    span.collapse-header-arrow {
        float: right;
    }

	table { 
        margin-top: 15px;
        width: 100%;
        border-collapse: collapse;
    }

    thead > tr > th {
        text-align: center;
    }

    tr:nth-of-type(odd) { 
        background: #eee; 
    }

    th { 
        background: #ccc;
        font-weight: bold; 
    }

    td, th { 
        padding: 10px; 
        border: 1px solid #ccc; 
        text-align: left; 
        font-size: 14px;
    }
		
	.status-span {
		cursor: default; 
		font-weight: bold; 
	}

	.item-label {
		font-size: 14px;
		font-weight: bold;
	}

	.item-value {
		font-size: 16px;
		color: #999;
		padding-top: 10px;
	}

	.separator {
		width: 100%;
		border-bottom: 1px solid #ccc;
		margin-top: 15px;
		margin-bottom: 15px;
	}

	.button-copy {
		position: absolute;
		left: 0;
		background: #222;
		color: #fff;
		font-size: 12px;
		padding: 4px 10px;
		border-radius: 4px;
		margin-top: -2px;
	}
</style>